module.exports = __webpack_public_path__ + "static/media/cancelAvatar.744826ad.svg";